import { spacingLayouts, TSpacingLayout } from '@apia/theme';
import { useCallback, useRef } from 'react';

export type TPanelLayout = TSpacingLayout;

export function usePanelContextLayout() {
  const elRef = useRef<HTMLDivElement | null>(null);
  const layoutRef = useRef<TPanelLayout>('clever');

  const clearClassNames = useCallback(() => {
    spacingLayouts.forEach((current) =>
      (
        elRef.current?.querySelector('.panel__content') as HTMLElement
      )?.classList.remove(current),
    );
  }, []);

  const setRef = useCallback(
    (el: HTMLDivElement) => {
      if (el instanceof HTMLDivElement) {
        elRef.current = el;
        clearClassNames();
        (el?.querySelector('.panel__content') as HTMLElement).classList.add(
          layoutRef.current,
        );
      }
    },
    [clearClassNames],
  );

  const setLayout = useCallback(
    (layout: TPanelLayout) => {
      if (layoutRef.current === layout) return;

      layoutRef.current = layout;
      clearClassNames();
      (
        elRef.current?.querySelector('.panel__content') as HTMLElement
      )?.classList.add(layoutRef.current);
    },
    [clearClassNames],
  );

  return { ref: setRef, setLayout };
}
